const NS = 'PouchActions';

export enum PouchActionsNames {
  POUCH_LOAD_STATUS_UPDATE = 'pouch-load-status-update',
  POUCH_SYNCED_DOCTYPE_TAG = 'pouch-synced-doctype-tag',
  POUCH_SYNCED_DOCTYPE_BOOKING = 'pouch-synced-doctype-booking',
  RECEIVE_CHANGE = 'receive-change',
  POUCH_SYNCED_DOCTYPE_EVENT = "pouch-synced-doctype-event",
  POUCH_SYNCED_DOCTYPE_LAYOUT = "pouch-synced-doctype-layout",
  POUCH_SYNCED_DOCTYPE_STATUS = "pouch-synced-doctype-status",
  POUCH_SYNCED_DOCTYPE_NOTE = "pouch-synced-doctype-note",
  POUCH_SYNCED_DOCTYPE_BLOCKOUT = "pouch-synced-doctype-blockout",
  POUCH_SYNCED_DOCTYPE_SCHEDULE = "pouch-synced-doctype-schedule",
  POUCH_SYNCED_DOCTYPE_SECTION = "pouch-synced-doctype-section",
  POUCH_SYNCED_DOCTYPE_TABLE = "pouch-synced-doctype-table",
  POUCH_SYNCED_DOCTYPE_SECTION_GROUP = "pouch-synced-doctype-section-group",
  POUCH_SYNCED_DOCTYPE_SERVICE_GROUP = "pouch-synced-doctype-service-group",
}

export enum PouchDocType {
  tag = 'tag',
  receiveChange = 'receiveChange',
  booking = 'booking',
  event = 'event',
  layout = 'layout',
  status = 'status',
  note = 'note',
  blockout = 'blockout',
  schedule = 'schedule',
  section = 'section',
  table = 'table',
  sectionGroup = 'sectionGroup',
  serviceGroup = 'serviceGroup',
}


export enum PouchLoadStatus {
  idle = 'idle',
  loading = 'loading',
  failed = 'failed',
  success = 'success',
}

class PouchActions {

  private $rootScope: any;
  private readyCB: () => void;

  setup($rootScope: any) {
    this.$rootScope = $rootScope;
    if (this.readyCB) {
      this.readyCB();
    }
  }

  registerForReadyCB(cb: () => void) {
    if (this.$rootScope) {
      cb();
    } else {
      this.readyCB = cb;
    }
  }

  getTagActionName(type: string): string {
    let actionName;
    switch (type) {
      case PouchDocType.tag:
        actionName = PouchActionsNames.POUCH_SYNCED_DOCTYPE_TAG;
        break;

      case PouchDocType.event:
        actionName = PouchActionsNames.POUCH_SYNCED_DOCTYPE_EVENT;
        break;

      case PouchDocType.receiveChange:
        actionName = PouchActionsNames.RECEIVE_CHANGE;
        break;

      case PouchDocType.booking:
        actionName = PouchActionsNames.POUCH_SYNCED_DOCTYPE_BOOKING;
        break;

      case PouchDocType.layout:
        actionName = PouchActionsNames.POUCH_SYNCED_DOCTYPE_LAYOUT;
        break;

      case PouchDocType.status:
        actionName = PouchActionsNames.POUCH_SYNCED_DOCTYPE_STATUS;
        break;

      case PouchDocType.note:
        actionName = PouchActionsNames.POUCH_SYNCED_DOCTYPE_NOTE;
        break;

      case PouchDocType.blockout:
        actionName = PouchActionsNames.POUCH_SYNCED_DOCTYPE_BLOCKOUT;
        break;

      case PouchDocType.schedule:
        actionName = PouchActionsNames.POUCH_SYNCED_DOCTYPE_SCHEDULE;
        break;

      case PouchDocType.section:
        actionName = PouchActionsNames.POUCH_SYNCED_DOCTYPE_SECTION;
        break;

      case PouchDocType.table:
        actionName = PouchActionsNames.POUCH_SYNCED_DOCTYPE_TABLE;
        break;

      case PouchDocType.sectionGroup:
        actionName = PouchActionsNames.POUCH_SYNCED_DOCTYPE_SECTION_GROUP;
        break;

      case PouchDocType.serviceGroup:
        actionName = PouchActionsNames.POUCH_SYNCED_DOCTYPE_SERVICE_GROUP;
        break;
    }

    return actionName;
  }

  updatePouchSyncedDoctype(type: PouchDocType, docIds?: any): void {
    const actionName = this.getTagActionName(type);
    // @todo: add back in if condition when all TagActionNames have been completed
    // if (!actionName) {
    //   console.warn(NS, "you need to specify a valid PouchDocType", type);
    //   return;
    // }
    this.$rootScope.$broadcast(actionName, docIds);
  }

  /**
   * This function'll use until get full PouchDocType list
   * To do: replace updatePouchSyncedDoctypeBeta with updatePouchSyncedDoctype
   */
  updatePouchSyncedDoctypeBeta(docType: string, payload?: any): void {
    this.$rootScope.$broadcast('pouch-synced-doctype-' + docType, payload);
  }

  handlePouchSyncedDoctype(type: PouchDocType, callback: (evt: any, payload?: any) => void): () => void {
    const actionName = this.getTagActionName(type);
    // console.log(NS, 'actionName', actionName)
    if (!actionName) {
      console.warn(NS, "you need to specify a valid PouchDocType", type);
      return () => {};// returns a no op
    }

    // returns the "unlisten" handler
    return this.$rootScope.$on(actionName, (evt: any, payload?: any) => {
      callback(evt, payload);
    });
  }

  setPouchLoadStatus(status: PouchLoadStatus): void {
    this.$rootScope.$broadcast(PouchActionsNames.POUCH_LOAD_STATUS_UPDATE, status);
  }

  handlePouchLoadStatus(cb: (payload: PouchLoadStatus) => void): () => void {
    return this.$rootScope.$on(PouchActionsNames.POUCH_LOAD_STATUS_UPDATE, (evt: any, payload?: any) => {
      cb(payload);
    });
  }

}

const instance = new PouchActions();
export default instance as PouchActions;
